import { useState } from "react";

function EndTime(props) {

  const [endTime, setEndTime] = useState(props.setCoursesObj.EndBy);
    const name = "EndBy";

    function handleStateChange (e) {
    let coursesObj = props.coursesObj;
    props.setCoursesObj({
      ...coursesObj,
      EndBy: e.target.value,
      default: false,
    });
    setEndTime(e.target.value);
  }

  return (
      <>
        <label htmlFor="endTime" className="majorLabel">Time the Class Ends By:</label>
        <input
            type="time"
            id="endTime"
            name={name}
            value={endTime}
            onChange={handleStateChange}
            className="selectBox dayTimeBox"
        />
      </>
  );
}

export default EndTime;
